/* @jsx h */
import { useCustomer } from "@app/vue/providers/Auth";
import { useMenu } from "@app/vue/providers/Menu";
import logoURL from "@lemmonhq/assets/images/branding/dark-favico.svg?url";
import { defineComponent, h, ref } from "vue";
import { RouterLink, useRoute } from "vue-router";
import { CustomerLanguageSelector } from "../../../components/CustomerLanguageSelector";

export const ShopNav = defineComponent({
  name: "ShopNav",
  setup(props) {
    const { shop } = useMenu();
    // cart.cart.serviceMethod
    const auth = useCustomer();
    const slug = shop.value.slug;
    const route = useRoute();
    const showInfoModal = ref(false);
    const { customer } = useCustomer();
    return () => {
      return (
        <div class="flex justify-between items-center py-2 px-2 md:px-4 sticky top-0 left-0 right-0 bg-base-100 border-b">
          <div class="flex justify-center items-center">
            <RouterLink
              class="hidden bg-base-300 border border-base-300 rounded flex justify-center items-center mr-2"
              to="/"
            >
              <img class="" src={logoURL} width="40px" />
            </RouterLink>
            <RouterLink to={`/restaurant/${slug}`} class="text-accent text-2xl">
              {shop.value.name}
            </RouterLink>{" "}
          </div>
          <div class="flex items-center gap-1 md:gap-2">
            <div class="flex py-0 gap-1 flex-1 justify-end hidden">
              <div class="flex items-center space-x-2 text-sm">
                <button
                  onClick={() => (showInfoModal.value = true)}
                  class="flex items-center justify-center"
                >
                  <span class="material-symbols-outlined badge badge-success text-2xl py-4">
                    info
                  </span>
                </button>
              </div>
            </div>
            {customer.value?.anon ? (
              <>
                <div
                  class="btn btn-primary hidden text-1xl"
                  onClick={() => {
                    auth.showAuthDialog();
                  }}
                >
                  <span class="material-symbols-outlined  text-2xl">lock</span>
                  Auth
                </div>
              </>
            ) : null}

            <RouterLink
              class="hidden text-2xl"
              to={`/restaurant/${slug}/reserve`}
            >
              <span class="material-symbols-outlined  text-4xl">
                calendar_month
              </span>
            </RouterLink>
            <CustomerLanguageSelector />
            <RouterLink
              class={
                route.path.startsWith(`/restaurant/${slug}/user/me`)
                  ? "text-accent"
                  : "text-accent/50"
              }
              to={`/restaurant/${slug}/account/profile`}
            >
              <span class="material-symbols-outlined  text-4xl">face</span>
            </RouterLink>
          </div>
        </div>
      );
    };
  },
});
